"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  SAI_PIP: 'SAI_PIP',
  SAI_TUB: 'SAI_TUB',
  MAKER_OTC: 'MAKER_OTC',
  OASIS_PROXY: 'OASIS_PROXY',
  SAI_PROXY: 'SAI_PROXY',
  PROXY_REGISTRY: 'PROXY_REGISTRY',
  DS_PROXY_FACTORY: 'DS_PROXY_FACTORY',
  DS_PROXY: 'DS_PROXY',
  MULTICALL: 'MULTICALL',
  SAI_CAGEFREE: 'SAI_CAGEFREE'
};
exports["default"] = _default;